const testimonials = [
  {
    quote:
      'দুর্দান্ত অ্যাপ! দ্রুত ও অভিনব উপায়ে বিজ্ঞান শেখার জন্য একটি খুব কার্যকর শিখন পদ্ধতি প্রয়োগ করা হয়েছে। কি দুর্দান্ত মজা! এই অসাধারণ অ্যাপটির  তৈরিতে যারা ছিলেন তাদের কঠোর পরিশ্রমের জন্য ধন্যবাদ। সিমুলেশন এর মাধ্যমে বিজ্ঞান শেখার ওপর নাম "অনুশীলন"!',
    name: 'শাহেদ তালুকদার',
    location: 'টাঙ্গাইল',
    img: 'https://i.ibb.co/xzXtLZR/shahed.jpg',
  },
  {
    quote:
      'এই ভার্চুয়াল সাইন্স ল্যাব আপনাকে অনেক সাহায্য করবে বিশেষত যখন আপনি বিজ্ঞানের ছাত্র হন। যারা এই জাতীয় সিমুলেশন তৈরী করেছে তাদের জন্য এটা দুর্দান্ত কাজ। আশাকটি এটি শিক্ষাথীদের মেধা বিকাশে ও বিজ্ঞান বুঝতে অভাবনীয় সাফল্য বয়ে আনবে। ',
    name: 'কামরুল হক',
    location: 'ঢাকা',
    img: 'https://i.ibb.co/cxQKQMQ/utash5.jpg',
  },
  {
    quote:
      'সিমুলেশন এর মাধ্যমে বিজ্ঞান শিখতে চমকপ্রদ অ্যাপ! দুর্দান্ত অভিজ্ঞতা এবং মজাদার বিষয়বস্তু! আপনাকে বিজ্ঞানের ধারণাগুলি পেতে এবং এ থেকে সর্বাধিক সুবিধা অর্জনের জন্য বিশদতে সবকিছুকে সহজ শর্তে ব্যাখ্যা করা হয়েছে। নির্দ্বিধায় পরিকল্পনাটি সত্যিই খুব ভাল',
    name: 'সালাউদ্দিন আয়ুব',
    location: 'গাজীপুর',
    img: 'https://i.ibb.co/BwjxNH9/ayub.jpg',
  },
  {
    quote:
      'আপনি যদি সিমুলেশন এর মাধ্যমে বিজ্ঞান চর্চা শুরু করতে চান তবে আপনি এই এপ্লিকেশনটি দিয়ে  শুরু করতে পারেন এটি বোঝা খুব সহজ এবং বিশেষত বাংলা ভাষায় সব কিছু থাকতে এটি অনেক বোধগম্য ও আনন্দদায়ক এবং সবকিছুই ফ্রীতে!',
    name: 'আর রাফিউ খান',
    location: 'ঢাকা',
    img: 'https://i.ibb.co/W05Ry6F/eshan.jpg',
  },
  {
    quote:
      'আমি এখন পর্যন্ত এটি ভালোবাসি! আমি সিমুলেশন গুলি ব্যবহার করে অনেক আনন্দ পেয়েছি এবং উপভোগ করেছি । আশাকরি এটি বিজ্ঞানীদের শিক্ষক -শিক্ষাদীদের নতুনভাবে বিজ্ঞান শেখার জন্য গ্রহণযোগ্য হয়ে উঠবে এবং সকলে অনেক বেশি উপভোগ করতে পারবে!',
    name: 'জনি মিয়া',
    location: 'টাঙ্গাইল',
    img: 'https://i.ibb.co/xCsvg3p/jony.jpg',
  },
  {
    quote:
      'খুব ভালো লাগে যখন দেখি আমাদের দেশে বিজ্ঞান চর্চা ও সিমুলেশন এর মাদ্ধমে আনন্দদায়ক উপায়ে বিজ্ঞান শেখানোর জন্য এরকম একটা এপ্লিকেশন বানানো হয়েছে। এটি আমাদের ভবিষ্যৎ প্রজন্মকে আর বিজ্ঞানমুখী গড়ে তুলবে বলে আমি মনে করি।',
    name: 'জাহিদ হাসান',
    location: 'গাজীপুর',
    img: 'https://i.ibb.co/RyvPbf0/shiplu.jpg',
  },
  {
    quote:
      'ভালোবাসা রইলো "অনুশীলন" এর প্রতি! যারা এটি তৈরি করেছেন তাদের ও সকল শিক্ষার্থীর প্রতি যারা এটিকে ব্যবহার করে বিজ্ঞান চর্চা ও গবেষণা করছেন আরো জ্ঞান আহরণ এর জন্য। শুভ কামনা রইলো বিজ্ঞান চর্চাকে আরও একধাপ সামনে এগিয়ে নিয়ে যাবার জন্য।',
    name: 'আনিসুর রহমান',
    location: 'টাঙ্গাইল',
    img: 'https://i.ibb.co/xXwQxD4/anisur.jpg',
  },
  {
    quote:
      'সিমুলেশন গুলো শিক্ষার্থীদের বিজ্ঞান বুঝতে ইন্টারেক্টিভ, ওয়েব-ভিত্তিক অভিজ্ঞতা সরবরাহ করে। এই ইন্টারেক্টিভ প্রযুক্তিগুলি শিক্ষার্থীদের বৈজ্ঞানিক তত্ত্ব, অভিজ্ঞতা এবং অনুসন্ধানের মধ্যে সম্পর্ক স্থাপনের জন্য শারীরিক ঘটনার চাক্ষুষ উপস্থাপনা উপস্থাপন করতে পারে।',
    name: 'রেজওয়ান মেহেরাব',
    location: 'মানিকগঞ্জ',
    img: 'https://i.ibb.co/8brF8VK/borshon.jpg',
  },
  {
    quote:
      'এই ভার্চুয়াল ল্যাব শিক্ষার্থীদের পরীক্ষাগার সরঞ্জাম পরিচালনা করতে, ডেটা অর্জন করতে এবং প্রযুক্তিগত মান পর্যবেক্ষণ কৌশল অনুসরণ করে। এটি শিক্ষার্থীদের সরঞ্জাম, উপকরণ এবং ল্যাব ইউনিটগুলি স্ক্রিনে বিষয়গতভাবে পরীক্ষা-নিরীক্ষার জন্য শিখতে সাহায্য করে। ',
    name: 'সাইফুল ইসলাম',
    location: 'ফরিদপুর',
    img: 'https://i.ibb.co/HGYJ26y/sagor.jpg',
  },
  {
    quote:
      'ভার্চুয়াল ল্যাব ব্যবহারকারী শিক্ষার্থীরা পরীক্ষাগুলির ধারণা, উদ্দেশ্য এবং ফলাফলগুলি বুঝতে সক্ষম হবে। সিমুলেশন অভিজ্ঞতার সাথে পরীক্ষাগুলি অনুকরণ করে ও স্বতন্ত্রভাবে পরীক্ষা-নিরীক্ষা গুলো শিক্ষার্থীদের তথ্য বুঝতে এবং স্মরণে রাখতে সহায়তা করে।',
    name: 'জাওয়াদ হোসাইন',
    location: 'ময়মনসিংহ',
    img: 'https://i.ibb.co/Wc8cTcC/jaowad.jpg',
  },
];

export default testimonials;
